<ion-header>
  <ion-toolbar mode="md" color="dark">
    <ion-title>
      <ng-container>{{ 'dining.assignGuest' | transloco }}</ng-container>
    </ion-title>
    <ion-buttons slot="end">
      <ion-button mode="md"
                  (click)="onCloseModal(true)">{{ 'common.close' | transloco }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content fullscreen>
  <div class="assign-guest">
    <div class="assign-guest__label">{{ 'dining.isPersonGuestOfDiner' | transloco }}</div>
    <div class="assign-guest__buttons">
      <ion-button mode="md"
                  color="dark"
                  (click)="onCloseModal(false, true)">{{ 'common.yes' | transloco }}
      </ion-button>

      <ion-button mode="md"
                  color="dark"
                  (click)="onCloseModal(false, false)">{{ 'common.no' | transloco }}
      </ion-button>
    </div>
  </div>
</ion-content>